define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('span', { 'className': this.getClass() }, this.getValue());
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/validations/validation-message/validation-message.rt
 ** module id = 185
 ** module chunks = 0
 **/